import type { Contact } from 'Contact/utils/contactTypes'
import type { ContactCreatePostType } from 'Work/components/Work/Sections/Team/CreateContactForm'
import { Operation } from 'fast-json-patch'

import { ListAsset } from 'Common/components/assets/AssetGridList'
import { servicesAsync } from 'Common/environment/environment'
import { fetchDelete, fetchGet, fetchPatch, fetchPost, fetchPut } from 'Common/utils/query/request'

const baseUrl = servicesAsync.contact('/v2/contacts')
const listsUrl = servicesAsync.contact('/v2/lists')
interface ContactPatch {
    id: number
    patchSet: Operation[]
}

interface ContactLinksRequest {
    id: number
    contactLinks: any
}

interface ContactAssetDeleteRequest {
    id: number
    assetId: number
}

interface ContactAssetPostRequest {
    id: number
    asset: any
}

interface ContactMergeRequest {
    sourceId: number
    destinationId: number
}

export const contactGet = async (contactId: number): Promise<Contact> => {
    return await fetchGet(`${await baseUrl}/${contactId}`)
}

export const contactDelete = async (contactId: number) => {
    return await fetchDelete(`${await baseUrl}/${contactId}`)
}

export const contactMerge = async (request: ContactMergeRequest) => {
    return await fetchPost(
        `${await baseUrl}/merge`,
        JSON.stringify({
            sourceContactId: request.sourceId,
            destinationContactId: request.destinationId,
        }),
    )
}

export const getContactLinks = async (contactId: number) => {
    const result = await fetchGet(`${await baseUrl}/${contactId}/links`)
    return result.contactLinks
}

export const putContactLinks = async (request: ContactLinksRequest) => {
    return await fetchPut(
        `${await baseUrl}/${request.id}/links`,
        JSON.stringify(request.contactLinks),
    )
}

export const getContactCompanyContacts = async (contactId: number) => {
    return await fetchGet(`${await baseUrl}/${contactId}/companycontacts`)
}

export const patchContact = async (request: ContactPatch) => {
    return await fetchPatch(`${await baseUrl}/${request.id}`, JSON.stringify(request.patchSet))
}

export const getContactRetailerInfo = async (contactId: number) => {
    return await fetchGet(`${await baseUrl}/${contactId}/resellerinfo`)
}

export const patchContactRetailerInfo = async (request: ContactPatch) => {
    return await fetchPatch(
        `${await baseUrl}/${request.id}/resellerinfo`,
        JSON.stringify(request.patchSet),
    )
}

export const postContact = async (contact: ContactCreatePostType) => {
    return await fetchPost(`${await baseUrl}`, JSON.stringify(contact))
}

export const getSelectionLists = async () => {
    return await fetchGet(`${await listsUrl}`)
}

export const getContactLists = async (contactId: number) => {
    return await fetchGet(`${await baseUrl}/${contactId}/lists`)
}

export const patchContactLists = async (request: ContactPatch) => {
    return await fetchPatch(
        `${await baseUrl}/${request.id}/lists`,
        JSON.stringify(request.patchSet),
    )
}

export const contactAssetsGet = async (contactId: number) => {
    return (await fetchGet(`${await baseUrl}/${contactId}/assets`)) as ListAsset[]
}

export const contactAssetsDelete = async (request: ContactAssetDeleteRequest) => {
    return await fetchDelete(`${await baseUrl}/${request.id}/assets/${request.assetId}`)
}

export const contactAssetsPost = async (request: ContactAssetPostRequest) => {
    return await fetchPost(`${await baseUrl}/${request.id}/assets`, JSON.stringify(request.asset))
}
